// PEME status filter tabs with optional pipeline sub-stage pills
import React from 'react';
import { PIPELINE_STAGES } from '../../constants/peme-stages';
import './peme-status-tabs.scss';

const TAB_ITEMS = [
  { value: 'all', label: 'All Members', countKey: 'all' },
  { value: 'scheduled', label: 'Scheduled', countKey: 'scheduled' },
  { value: 'inClinic', label: 'In Clinic', countKey: 'inClinic' },
  { value: 'pending', label: 'Pending', countKey: 'pending' },
];

const PemeStatusTabs = ({ activeTab, onTabChange, counts = {}, stageFilter, onStageFilter, pipelineStages = [] }) => {
  // Build lookup for stage counts from pipeline overview data
  const stageCounts = {};
  let allStagesTotal = 0;
  pipelineStages.forEach((s) => {
    if (s.name !== 'Fit to Work') {
      stageCounts[s.name] = s.count || 0;
      allStagesTotal += s.count || 0;
    }
  });
  return (
    <div className="peme-status-tabs">
      {/* Tab bar */}
      <div className="tw-flex tw-overflow-x-auto tw-gap-6 tw-border-b tw-border-gray-200 tw-text-sm">
        {TAB_ITEMS.map((tab) => {
          const count = counts[tab.countKey] ?? 0;
          const isActive = activeTab === tab.value;
          return (
            <button
              key={tab.value}
              onClick={() => onTabChange(tab.value)}
              className={[
                'tw-pb-3 tw-font-medium tw-transition-colors tw-whitespace-nowrap',
                'tw-bg-transparent tw-border-0 tw-cursor-pointer tw-px-0',
                isActive
                  ? 'tw-text-indigo-600 tw-border-b-2 tw-border-indigo-600'
                  : 'tw-text-gray-500 hover:tw-text-gray-700',
              ].join(' ')}
            >
              {tab.label} ({count})
            </button>
          );
        })}
      </div>

      {/* Sub-stage pills — only visible when Pending tab active */}
      {activeTab === 'pending' && (
        <div className="tw-flex tw-flex-wrap tw-gap-2 tw-mt-3">
          {/* All Stages pill */}
          <button
            onClick={() => onStageFilter && onStageFilter(null)}
            className={[
              'tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-medium tw-cursor-pointer tw-border tw-transition-colors',
              stageFilter === null
                ? 'tw-bg-indigo-50 tw-text-indigo-700 tw-border-indigo-200'
                : 'tw-bg-white tw-text-gray-600 tw-border-gray-200 hover:tw-bg-gray-50',
            ].join(' ')}
          >
            All Stages{allStagesTotal > 0 ? ` (${allStagesTotal})` : ''}
          </button>

          {PIPELINE_STAGES.filter((s) => s !== 'Fit to Work').map((stage) => (
            <button
              key={stage}
              onClick={() => onStageFilter && onStageFilter(stage)}
              className={[
                'tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-medium tw-cursor-pointer tw-border tw-transition-colors',
                stageFilter === stage
                  ? 'tw-bg-indigo-50 tw-text-indigo-700 tw-border-indigo-200'
                  : 'tw-bg-white tw-text-gray-600 tw-border-gray-200 hover:tw-bg-gray-50',
              ].join(' ')}
            >
              {stage}{stageCounts[stage] > 0 ? ` (${stageCounts[stage]})` : ''}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PemeStatusTabs;
